module.exports = __webpack_public_path__ + "static/agency-banner-d477a53e32c9a286afdb8d8a0f92b96c.png";